import { render, staticRenderFns } from "./Ddex.vue?vue&type=template&id=324e763c&scoped=true&"
import script from "./Ddex.vue?vue&type=script&lang=js&"
export * from "./Ddex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e763c",
  null
  
)

export default component.exports